import { CampaignSettingsMap } from './types';

export enum CampaignSetting {
  TouchedSteps = 'touchedSteps',
}

export const DEFAULT_CAMPAIGN_SETTINGS: CampaignSettingsMap = {
  [CampaignSetting.TouchedSteps]: {
    budget: false,
    summary: false,
    audiences: false,
    locations: false,
  },
};
